import { onAuthStateChanged, Unsubscribe } from "firebase/auth";
import { getDatabase, ref, onValue } from "firebase/database";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShowType } from "../api";
import Navbar from "../components/Navbar";
import { auth } from "../firebase";

type NowWatchingSHowType = {
  id: number;
  title: string;
  image: string;
  counter: number;
};

const NowWatching = () => {
  const navigate = useNavigate();
  const [watching, setWatching] = useState([] as NowWatchingSHowType[]);

  useEffect(() => {
    let watchingUnsubscribe: Unsubscribe | undefined = undefined;

    onAuthStateChanged(auth, (user) => {
      if (!user) navigate("/login");
      else {
        const db = getDatabase();
        const dbWatching = ref(db, "watching/");
        watchingUnsubscribe = onValue(dbWatching, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            let watching: NowWatchingSHowType[] = [];
            const shows: ShowType[] = Object.values(data);
            shows.map((show) => {
              if (Object.keys(watching).length === 0) {
                watching.push({
                  id: show.id,
                  title: show.title,
                  image: show.image,
                  counter: 1,
                });
              } else if (watching.find((watchingShow) => watchingShow.id === show.id)) {
                const index = watching.findIndex((watchingShow) => watchingShow.id === show.id);
                watching[index].counter++;
              } else {
                watching.push({
                  id: show.id,
                  title: show.title,
                  image: show.image,
                  counter: 1,
                });
              }
            });
            watching.sort((a, b) => b.counter - a.counter);
            setWatching(watching);
            console.log(watching);
          } else setWatching([]);
        });
      }
    });

    return () => {
      if (watchingUnsubscribe) watchingUnsubscribe();
    };
  }, []);
  return (
    <>
      <Navbar page={"nowwatching"} />
      <h1 className="text-3xl text-center font-bold m-6 dark:text-slate-300">Now Watching</h1>
      <div className="grid grid-cols-3 text-center m-3">
        {watching.slice(0, 3).map((show, key) => (
          <div
            className={`m-2 ${
              key === 0
                ? "relative top-0 order-2"
                : key === 1
                ? "relative top-10 order-1"
                : "relative top-10 order-3"
            }`}
          >
            <button onClick={() => navigate(`/detail/${show.id}`)}>
              <div
                className={`relative bg-cover rounded-full outline outline-3 outline-offset-4 ${
                  key === 0
                    ? "outline-yellow-500"
                    : key === 1
                    ? "outline-gray-300"
                    : "outline-amber-600"
                }`}
                style={{
                  backgroundImage: `url(${show.image})`,
                  minWidth: key === 0 ? "6.2rem" : "5rem",
                  minHeight: key === 0 ? "6.2rem" : "5rem",
                }}
              >
                <div className="flex justify-center">
                  <div
                    className={`absolute -bottom-5  w-8 h-8 flex justify-center items-center text-sm font-bold ${
                      key === 0 ? "bg-yellow-500" : key === 1 ? "bg-gray-300" : "bg-amber-600"
                    } rounded-full`}
                  >
                    {key + 1}
                  </div>
                </div>
              </div>
            </button>
            <div className="overflow-hidden mt-5">
              <button onClick={() => navigate(`/detail/${show.id}`)}>
                <p className="truncate text-md text-black dark:text-slate-300 font-semibold">
                  {show.title}
                </p>
              </button>
              <p className="truncate text-sm text-slate-500 dark:text-slate-600 font-medium">
                {show.counter} {show.counter > 1 ? "Users" : "User"}
              </p>
            </div>
          </div>
        ))}
      </div>
      {watching.slice(3).map((show, key) => (
        <div key={key} className="m-5 mt-10 flex items-center gap-3 ">
          <button onClick={() => navigate(`/detail/${show.id}`)}>
            <div
              className="bg-cover rounded-full"
              style={{
                backgroundImage: `url(${show.image})`,
                minWidth: "4.5rem",
                minHeight: "4.5rem",
              }}
            ></div>
          </button>
          <div className="space-y-0.5 overflow-hidden">
            <button onClick={() => navigate(`/detail/${show.id}`)}>
              <p className="truncate text-md text-black dark:text-slate-300 font-semibold">
                {show.title}
              </p>
            </button>
            <p className="truncate text-sm text-slate-500 dark:text-slate-600 font-medium">
              {show.counter} {show.counter > 1 ? "Users" : "User"}
            </p>
          </div>
          <div className="ml-auto text-md font-bold italic text-blue-600 dark:text-slate-200">
            #{key + 4}
          </div>
        </div>
      ))}
    </>
  );
};

export default NowWatching;
